// extracted by mini-css-extract-plugin
export var cardFill = "card-module--cardFill--u+AgN";
export var cardImage = "card-module--cardImage--6v9nA";